var lang = require('./lang')
var date = require('./date')
var browser = require('./browser')
var dom = require('./dom')

module.exports = lang.extend({}, lang, date, browser, dom)



//////////////////
// WEBPACK FOOTER
// ./~/date-time-picker/src/core/utils/index.js
// module id = 70
// module chunks = 0